import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import update from 'react-addons-update';
import styled from 'styled-components';
import { withTranslation, withNamespaces } from "react-i18next";

// styles
import style from '../../Styles/Containers/Auth_Error.module.css'

// component
import Header from '../../Components/Header/header'
import Button from '../../Components/Button'
import CheckList from '../../Components/CheckList'
import Spinner from '../../Components/Spinner'
import CheckItem from "../../Components/CheckList/CheckItem";


// Actions
import {action} from "../../Data";

// Const
import * as Const from "../../Data/const";

const EtcInput = styled.input.attrs((props) => ({
    disabled: props.disabled || false
}))`
        width: 100%;
        height: 100%;
        background-color: #f8f8f8;
        font-size: 14px;
        outline: none;
        border: none;
        border-bottom: 1px solid #ccc;
        color: ${props => props.disabled ? '#ccc' : '#555'};
        padding: 20px 8px;
        box-sizing: border-box;
        
        ::placeholder {
            color: #aaa;
        }
    `

class AuthErrorContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            feedSelect: [],
            checked: 1,
            feedSelectText: null,
            feedManual: '',
            productLocale: {},
            checkList: [],
            productReleaseCode: '',
            confirmGeoCode: {},

            isLoading: true,
            isNormal: false,
        }
        this.getParameterByName = this.getParameterByName.bind(this);
        this.getFeedSelect = this.getFeedSelect.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFeedSelectText = this.handleFeedSelectText.bind(this);

        this.fallbackUUID = null;

        console.log(this.props);
    }

    getRequestUUID() {
        if (this.props.UUID) return this.props.UUID;
        if (!this.fallbackUUID) {
            this.fallbackUUID = Const.getUUID() || ('web-' + Date.now() + '-' + Math.random().toString(36).slice(2));
        }
        return this.fallbackUUID;
    }
    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }


    componentDidMount() {
        let productReleaseCode = this.getParameterByName('id') //
        let time = this.getParameterByName('time'); //
        let lng = this.getParameterByName('lng'); //
        let lat = this.getParameterByName('lat');
        let country = this.getParameterByName('country');
        let city = this.getParameterByName('city');
        let ELocale = 'en';

        if (!productReleaseCode) {
            Const.showAlert('', "파라미터로 전달받은 코드가 없습니다.");
            this.setState({ isLoading: false })
            return;
        }

        this.setState({
            productReleaseCode: productReleaseCode,
            confirmGeoCode: {
                lat: lat || "asdf", // asdf 시 별도 처리하도록 서버로직에 있음 (util_map.js)
                lng: lng || "asdf",
                country: country || "Unknown",
                city: city || "Unknown"
            }
        }, () => {

            switch (country) {
                case 'korea' :
                    ELocale = 'kr';
                    break;
                case 'china' :
                    ELocale = 'cn';
                    break;
            }

            let params = {
                uuid: this.getRequestUUID(),
                productReleaseCode: productReleaseCode,
                ELocale: ELocale,
                confirmGeoCode: this.state.confirmGeoCode,
            }

            this.props.dispatch(action.eUSER.getProductConfirmError(params))
                .then((response) => {
                    if (!response.product[this.props.COUNTRY_CODE]) throw new Error('No Product');
                    if (!response.product[this.props.COUNTRY_CODE].feedSelect) throw new Error('No Feed');

                    this.setState({
                        isNormal: response.isNormal
                    }, () => {
                        if (this.state.isNormal) {
                            alert('정상등록 된 제품입니다.');
                            this.props.history.push('/user/product?id=' + productReleaseCode);
                        }
                    });

                    // let feedSelect = response.product[this.props.COUNTRY_CODE].feedSelect;
                    // if (response.product[this.props.COUNTRY_CODE].feedManual) {
                    //     feedSelect.push(response.product[this.props.COUNTRY_CODE].feedManual);
                    // }

                    let checkList = (response.product[this.props.COUNTRY_CODE].feedSelect || []).map((item, index) => {
                        let checkListItem = {
                            title: item,
                            isChecked: false,
                            onClick: (idx) => this.checkItem(idx)
                        };

                        if ((index + 1) == response.product[this.props.COUNTRY_CODE].feedSelect.length) {
                            checkListItem.feedSelectText = '';
                        }

                        return checkListItem;
                    });

                    this.setState({
                        isLoading: false,
                        productReleaseCodeConfirmed: response.productReleaseCode,
                        productLocale: response.product[this.props.COUNTRY_CODE] || {},
                        checkList: checkList,
                    })
                })
                .catch((err) => {
                    this.setState({
                        isLoading: false,
                    }, () => {
                        if (err.response) {
                            let errData = Const.getError(err.response.data, this.props.COUNTRY_CODE);
                            if (!errData.code) {
                                Const.showAlert('', errData.errorMessage);
                                return;
                            }
                        } else {
                            console.log('Unknown err', err)
                        }
                    })
                });
        })
        /* productReleaseCode = productReleaseCode ? productReleaseCode : 'naqffe0000000000';*/

    }

    getFeedSelect() {
        console.log(this.state.productLocale);
        if (!this.state.productLocale.feedSelect) {
            Const.showAlert('', Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]['UNKNOWN_ERROR']);
            return [];
        }

        return this.state.productLocale.feedSelect.map((item) => {
            return {
                title: item,
                isChecked: false,
                onClick: (idx) => this.checkItem(idx)
            }
        });
    }

    handleSubmit() {
        const checkIsChecked = this.state.checkList.find((item) => {
            return item.isChecked
        });

        if (!checkIsChecked) {
            Const.showAlert('', Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]['FEED_NOT_CHECKED']);
            return;
        }

        const q = {};

        let isEtc = this.state.checkList.indexOf(checkIsChecked) + 1 == this.state.checkList.length;

        // 기타인지 체크
        if (isEtc && !this.state.feedSelectText) {
            Const.showAlert('', Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]['FEED_ETC_NOT_EXIST']);
            return;
        }

        // 로그인했는지 체크, 했으면 uid 실어줌
        if (this.props.eSESSION.uid) {
            q.uid = this.props.eSESSION.uid
        }

        q.uuid = this.getRequestUUID();
        q.productReleaseCode = this.state.productReleaseCode;
        q.confirmGeoCode = this.state.confirmGeoCode;
        q.ELocale = this.props.COUNTRY_CODE;
        q.feedSelectIndex = this.state.checkList.indexOf(checkIsChecked);
        q.feedSelectText = isEtc ? this.state.feedSelectText : null;

        this.props.dispatch(action.eUSER.userProductFeed(q)).then((res) => {
            if (res.result) {
                this.props.history.push('/user/auth/survey');
            } else {
                throw new Error('No Feed Result');
            }
        }).catch((err) => {
            if (err.response) {
                let errData = Const.getError(err.response.data, this.props.COUNTRY_CODE);
                if (!errData.code) {
                    Const.showAlert('', errData.errorMessage);
                    return;
                }
            } else {
                console.log('Unknown err', err)
            }
        });
    }

    handleFeedSelectText(e) {
        this.setState({ feedSelectText: e.target.value });
    }

    checkItem(selectedIdx) {
        let newCheckList = this.state.checkList.map((item, idx) => {
            if (idx === selectedIdx) {
                item.isChecked = true;
            } else {
                item.isChecked = false;
            }

            return item;
        });

        this.setState({ checkList: newCheckList })
    }

    render() {
        const { t } = this.props;

        let renderCheckItem = (list) => {
            return list.length > 0 ? list.map((item, idx) => {
                return <CheckItem onClick={(idx) => item.onClick(idx)} key={idx} id={idx} title={item.title} isChecked={item.isChecked} bottomContents={item.bottomContents}/>
            }) : null
        }

        let etcCheckItem = (this.state.checkList || []).find((item) => {
            return item.feedSelectText !== undefined
        })
        let etcIndex = (this.state.checkList || []).findIndex((item) => {
            return item.feedSelectText !== undefined
        })

        let renderBottomContents = (
            this.state.checkList.length > 0 ?
            <>
                <CheckItem onClick={() => etcCheckItem.onClick(etcIndex)} id={etcIndex} title={etcCheckItem.title} isChecked={etcCheckItem.isChecked} customStyle={{borderBottom: 'none'}}/>
                <div style={{ paddingRight: '20px', width: '100%', boxSizing: 'border-box' }}>
                    <EtcInput disabled={!etcCheckItem.isChecked} placeholder={this.state.productLocale.feedManual} onChange={(e) => this.handleFeedSelectText(e)}/>
                </div>
            </> : null
        )

        return (
            <div className={style.container}>
                <Header
                    onClosePress={(e) => {
                        Const.userAppCloseActivity();
                    }}
                    content={t('authentication_result')}
                />
                {
                    this.state.isLoading ? <div className={style.spinnerWrapper}><Spinner/></div>
                        : <>
                            <div className={style.contents} style={{marginTop: 64}}>
                                <div className={style.alert_font}>{t('incorrect_code')}</div>
                                <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-incorrect.svg"} className={style.present_img}></img>
                                <div className={style.cinfirm_font}>{t('cant_find_code')}</div>
                                <div className={style.small_font} style={{marginTop: 16}}>{t('check_code_again')}</div>
                                <div className={style.code_area}>
                                    <span className={style.code_font}>{t('inserted_code')}</span>
                                    <span className={style.code_font}>•</span>
                                    <span className={style.code_font}>{this.state.productReleaseCode}</span>
                                </div>
                                <div className={style.small_font} style={{margin: 40, marginBottom: 41, whiteSpace: 'pre-wrap'}}>
                                    {t('contact_customer_center_error')}
                                </div>
                            </div>
                            <div className={style.contents} style={{marginTop: 8}}>
                                <div className={style.bottom_border}>
                                    <div className={style.title_font}>{this.state.productLocale.feedTitle || t('select_product_place')}</div>
                                </div>
                                <div className={style.bottom_border}>
                                    <div className={style.desc_font}>
                                        {this.state.productLocale.feedText || <>{t('to_improve_service')}</>}
                                    </div>
                                </div>
                                <CheckList
                                    list={(this.state.checkList || []).filter((item) => {return item.feedSelectText == undefined})}
                                    customRenderCheckItem={renderCheckItem}
                                    bottomContents={renderBottomContents}
                                    onChange={(text) => this.handleFeedSelectText(text)}
                                />
                            </div>
                            <div className={style.submit_button}>
                                <Button title={this.state.productLocale.feedbackButtonText || t('submit_survey')} onClick={() => this.handleSubmit()}></Button>
                            </div>
                        </>
                }

            </div>
        )
    }
}

export default connect((state) => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
        COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE,
        UUID: state.data.eSESSION.UUID,
    }
})(withRouter(withTranslation()(AuthErrorContainer)));